export default __webpack_public_path__ + "static/media/searching-octopus.24ac3d14.png";